import { render, staticRenderFns } from "./clientUser-email.vue?vue&type=template&id=2022fd25&scoped=true"
import script from "./clientUser-email.vue?vue&type=script&lang=js"
export * from "./clientUser-email.vue?vue&type=script&lang=js"
import style0 from "./clientUser-email.vue?vue&type=style&index=0&id=2022fd25&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2022fd25",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/data/workspace/KCC_AUDIT_PROD_Frontend/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2022fd25')) {
      api.createRecord('2022fd25', component.options)
    } else {
      api.reload('2022fd25', component.options)
    }
    module.hot.accept("./clientUser-email.vue?vue&type=template&id=2022fd25&scoped=true", function () {
      api.rerender('2022fd25', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/siteSetting/clientUser-email.vue"
export default component.exports